import React from "react";
import { useFormContext } from "react-hook-form";
import { TextField } from "@mui/material";
import { Text } from "$components";
import CField from "$forms/CField";
import ScheduleSelect from "$forms/ScheduleSelect";
import { useStyles } from "../styles";
import useAuth from "$hooks/useAuth";
import { Warehouse } from "$types";

export const EntrepotFormDelivery: React.FC = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<Warehouse>();
  const classes = useStyles();
  const { isAdmin } = useAuth();

  return (
    <>
      <span className="PlaceHolderText">
        <Text>Horaires de livraison</Text>
      </span>
      <div className={classes.newFormFieldsRow}>
        <div className={classes.newFormFieldsCol}>
          <CField
            control={control}
            name="delivery.am"
            error={errors.delivery?.am}
            label="Matin"
          >
            {(props) => (
              <ScheduleSelect error={errors.delivery?.pm} {...props} />
            )}
          </CField>
        </div>
        <div className={classes.newFormFieldsCol}>
          <CField
            control={control}
            name="delivery.pm"
            error={errors.delivery?.pm}
            label="Après-midi"
          >
            {(props) => (
              <ScheduleSelect
                isMorning={false}
                error={errors.delivery?.pm}
                {...props}
              />
            )}
          </CField>
        </div>
      </div>
      <div className={classes.newFormFieldsRow}>
        <CField
          control={control}
          disabled={!isAdmin()}
          name="notes"
          label="Notes"
          error={errors.notes}
        >
          {(props) => (
            <TextField
              {...props}
              variant="outlined"
              style={{ width: "100%" }}
              multiline
              minRows={3}
            />
          )}
        </CField>
      </div>
    </>
  );
};
